/** @jsxImportSource @emotion/react */
import { cx } from '@emotion/css';
import type { PropsWithChildren, FC, ComponentProps } from 'react';

type Props = ComponentProps<'div'> & {
  /** Use to force show the feedback, else use with className `is-valid` or `is-invalid` */
  show?: boolean;
  /** Indicate that the feedback is for valid input value */
  valid?: boolean;
  /** Render feedback as a tooltip */
  tooltip?: boolean;
};

const ODSFormFeedback: FC<PropsWithChildren<Props>> = ({
  className,
  children,
  show,
  valid,
  tooltip,
  ...props
}) => {
  const validMode = tooltip ? 'tooltip' : 'feedback';

  return (
    <div
      {...props}
      className={cx(
        className,
        'user-select-none m-0',
        valid ? `valid-${validMode}` : `invalid-${validMode}`
      )}
      css={{ ...(show && { display: 'block' }), '&:empty': { display: 'none' } }}
    >
      {children}
    </div>
  );
};

export default ODSFormFeedback;
